import * as actionTypes from '../actionTypes/editCoverLetterForm';

export default {
  updateSection: (params) => ({
    type: actionTypes.UPDATE_SECTION,
    payload: params,
  }),

  setDragOverCords: (params) => ({
    type: actionTypes.SET_DRAG_OVER_CORDS,
    payload: params,
  }),

  setPages: (params) => ({
    type: actionTypes.SET_PAGES,
    payload: params,
  }),

  updateExport: (params) => ({
    type: actionTypes.UPDATE_EXPORT,
    payload: params,
  }),

  resetHistory: (params) => ({
    type: actionTypes.RESET_HISTORY,
    payload: params,
  }),

  setCounter: (params) => ({
    type: actionTypes.SET_COVER_LETTER_COUNTER_VALUE,
    payload: params,
  }),

  setSaveStatus: (params) => ({
    type: actionTypes.SET_SAVE_STATUS,
    payload: params,
  }),

  setCoverLetterType: (params) => ({
    type: actionTypes.SET_COVER_LETTER_TYPE,
    payload: params,
  }),

  setDrag: (params) => ({
    type: actionTypes.SET_DRAG,
    payload: params,
  }),

  showError: (params) => ({
    type: actionTypes.SHOW_ERROR,
    payload: params,
  }),

  updateEventTypes: (params) => ({
    type: actionTypes.UPDATE_EVENT_TYPES,
    payload: params,
  }),
  updateEditedInputs: (params) => (dispatch) => {
    let actionData = {
      payload: {
        ...params,
      },
    };

    actionData = {
      ...actionData,
      type: actionTypes.UPDATE_EDITED_INPUTS,
    };

    dispatch(actionData);
  },
};
